import React from "react";
import "@fontsource-variable/quicksand";
import xperMark from "../images/xper-mark.svg";

function SubLogo({ product }) {
  return (
    <div className="mb-6 flex items-center gap-[0.8rem] text-main-dark">
      <img src={xperMark} alt="" aria-hidden="true" className="h-[4.8rem] w-[4.8rem] shrink-0 md:h-[6.4rem] md:w-[6.4rem]" />
      <div className="flex flex-col items-center justify-center leading-none">
        <span
          className="block text-[2.8rem] leading-none tracking-[0.1em] text-main-dark md:text-[4rem] -mb-[0.4rem]"
          style={{ fontFamily: "'Quicksand Variable', 'DMSans', sans-serif", fontWeight: 650 }}
        >
          XPER
        </span>
        <span
          className="block text-[2.08rem] text-secondary"
          style={{ fontFamily: "'Quicksand Variable', 'DMSans', sans-serif", fontWeight: 650 }}
        >
          {product}
        </span>
      </div>
    </div>
  );
}

export default SubLogo;
